const { flex } = window;
const { React } = flex.lib;
const { adobe } = flex.tracking;

import { ADOBE_CONSTANTS } from '../../../../../shared/js/constants';
import image from '../../../../../shared/img/tppayoff/landing-content.jpg';

function Content() {
    function onLoginClick() {
        adobe.sendCustomEvent({
            customClickName: 'tppayoff:login',
            signature: ADOBE_CONSTANTS.FIREBALL_SIGNATURE
        });

        flex.redirect('/sso');
    }

    return (
        <div className="payoff-landing__content">
            <div className="payoff-landing__content-image">
                <img src={image} alt="Lease Payoff Tool" width="100%" />
            </div>
            <div className="payoff-landing__text-content">
                <div className="payoff-landing__text">WELCOME TO THE</div>
                <div className="payoff-landing__text">MANHEIM PAYOFF TOOL</div>
                <button onClick={onLoginClick} className="payoff-landing__login-button">
                    Sign In
                </button>
            </div>
        </div>
    );
}

module.exports = Content;
